import moment from 'moment';
import {
	clearReservationTime,
	changeReservationStep,
	getReservationTime,
	getReservationDateWithOrder,
} from 'actions/reservation';
import { getOrderById } from 'actions/booking';
import { closeAlert } from 'actions/alert';

import { withAsyncEnterLoader, withAsyncChangeLoader, withLoader } from 'util/routeHelper';
import { getRoomById } from 'actions/room';

export default store => ({
	path: 'checkout',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'BookingCheckout',
				),
			store,
			'BookingCheckout',
		),
	},
	onEnter: withAsyncEnterLoader(
		async (
			{ params: { id: orderId }, location: { query: { step = 'reservation' } } },
			__,
			updateRatio,
		) => {
			store.dispatch(closeAlert('reserve'));
			store.dispatch(changeReservationStep(step));
			await store.dispatch(getOrderById(orderId));
			updateRatio(0.8);

			if (step === 'reservation') {
				store.dispatch(clearReservationTime());

				const { booking } = store.getState();
				const roomId = booking.data[orderId].room.id;
				const endDate = moment(booking.data[orderId].dateTo)
					.add(-1, 'weeks')
					.hour(8)
					.minute(0)
					.format('YYYY-MM-DD HH:mm:ss');

				await Promise.all([
					store.dispatch(getRoomById(roomId)),
					store.dispatch(getReservationTime(endDate, roomId, 'MORNING')),
					store.dispatch(getReservationTime(endDate, roomId, 'AFTERNOON')),
					store.dispatch(getReservationDateWithOrder(orderId, 'CHECKOUT')),
				]);
			}
		},
		store,
		'ENTER_BOOKING_CHECKOUT',
	),
	onChange: withAsyncChangeLoader(
		async (
			_,
			{ params: { id: orderId }, location: { query: { step = 'reservation' } } },
			__,
			updateRatio,
		) => {
			store.dispatch(closeAlert('reserve'));
			store.dispatch(changeReservationStep(step));
			await store.dispatch(getOrderById(orderId));
			updateRatio(0.8);

			if (step === 'reservation') {
				store.dispatch(clearReservationTime());

				const { booking } = store.getState();
				const roomId = booking.data[orderId].room.id;
				const endDate = moment(booking.data[orderId].dateTo)
					.add(-1, 'weeks')
					.hour(8)
					.minute(0)
					.format('YYYY-MM-DD HH:mm:ss');

				await Promise.all([
					store.dispatch(getReservationTime(endDate, roomId, 'MORNING')),
					store.dispatch(getReservationTime(endDate, roomId, 'AFTERNOON')),
					store.dispatch(getReservationDateWithOrder(orderId, 'CHECKOUT')),
				]);
			}
		},
		store,
		'CHANGE_BOOKING_CHECKOUT',
	),
});



// WEBPACK FOOTER //
// ./src/routes/User/Booking/Checkout/index.js